import React, { ReactNode } from "react";
import "./SubscriptionSuccessBox.scss";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { Button } from "src/app/components/Button/Button";
import classNames from "classnames";
import { ReactComponent as TickIcon } from "src/images/tick-empty-green-circle.svg";
import { ReactComponent as LoaderDots } from "src/images/loader-dots.svg";
import SubscriptionPageWrapper, {
  SubscriptionPageContent,
} from "../SubscriptionPageWrapper/SubscriptionPageWrapper";

interface Props {
  children: ReactNode;
  onContinueButtonClick?: () => void;
  backButtonFunction?: () => void;
  backButtonText?: string | ReactNode;
}

function SubscriptionSuccessBox(props: Props) {
  const {
    children,
    onContinueButtonClick,
    backButtonFunction,
    backButtonText,
  } = props;

  return (
    <SubscriptionPageWrapper>
      <SubscriptionPageContent
        className="subscription-success-box"
        width={550}
        backButtonFunction={backButtonFunction}
        backButtonText={backButtonText}
      >
        <TickIcon className="subscription-success-box__tick" />
        <span className="subscription-success-box__title">
          <IDHFormattedMessage id="ws_success" defaultMessage="Success" />!
        </span>

        {children}

        {Boolean(onContinueButtonClick) && (
          <Button variant="blue" onClick={onContinueButtonClick} size="large">
            <IDHFormattedMessage id="ws_continue" defaultMessage="Continue" />
          </Button>
        )}
      </SubscriptionPageContent>
    </SubscriptionPageWrapper>
  );
}

export default SubscriptionSuccessBox;

interface TextProps {
  children: ReactNode;
  bold?: boolean;
  marginTop?: number;
}

export function SubscriptionSuccessBoxText(props: TextProps) {
  const { children, bold, marginTop } = props;

  return (
    <div
      className={classNames("subscription-success-box__text", {
        "subscription-success-box__text--bold": bold,
      })}
      style={{ marginTop }}
    >
      {children}
    </div>
  );
}

interface LoaderProps {
  children: ReactNode;
}

export function SubscriptionSuccessBoxLoader(props: LoaderProps) {
  const { children } = props;

  return (
    <div className="subscription-success-box__loader">
      <LoaderDots />
      {children}
    </div>
  );
}
